import React, { useEffect, useState } from 'react';
import { Camera, GraduationCap, Globe, Briefcase, ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button, Card } from '../components/ui/Primitives';

// === ДАНІ ДЛЯ СТОРІНКИ "МОДЕЛЯМ" ===

const modelsData = [
  {
    id: 1,
    name: 'Олена, 34 роки',
    categoryText: 'Краків, Польща',
    flag: 'https://flagcdn.com/w20/pl.png',
    image: 'https://i.postimg.cc/zGC8z9fz/Gemini-Generated-Image-2mr7th2mr7th2mr7.png'
  },
  {
    id: 2,
    name: 'Ірина, 27 років',
    categoryText: 'Київ, Україна',
    flag: 'https://flagcdn.com/w20/ua.png',
    image: 'https://i.postimg.cc/wB9H70tp/Gemini-Generated-Image-umgu8oumgu8oumgu.png'
  },
  {
    id: 3,
    name: 'Camila, 26 років',
    categoryText: 'Сан-Паулу, Бразилія',
    flag: 'https://flagcdn.com/w20/br.png',
    image: 'https://i.postimg.cc/K8PxGd8p/Gemini-Generated-Image-jjbmt5jjbmt5jjbm.png'
  },
  {
    id: 4,
    name: 'Giulia, 33 роки',
    categoryText: 'Мілан, Італія',
    flag: 'https://flagcdn.com/w20/it.png',
    image: 'https://i.postimg.cc/PqdhP2Ls/Gemini-Generated-Image-jrpyuvjrpyuvjrpy.png'
  },
  {
    id: 5,
    name: 'Софія, 30 років',
    categoryText: 'Одеса, Україна',
    flag: 'https://flagcdn.com/w20/ua.png',
    image: 'https://i.postimg.cc/cJdZrXKx/Gemini-Generated-Image-o75mk7o75mk7o75m.png'
  },
  {
    id: 6,
    name: 'Emily, 38 років',
    categoryText: 'Ванкувер, Канада',
    flag: 'https://flagcdn.com/w20/ca.png',
    image: 'https://i.postimg.cc/1zyPfJ8k/Gemini-Generated-Image-tdo1n2tdo1n2tdo1.png'
  }
];

const giftsData = [
  {
    id: 1,
    name: 'Ведмедик та ігристе вино',
    image: 'https://i.postimg.cc/y8cyHf1m/IMG-1977.jpg'
  },
  {
    id: 2,
    name: 'Сережки Van Cleef',
    image: 'https://i.postimg.cc/GmGxCMLK/IMG-1979.jpg'
  },
  {
    id: 3,
    name: 'Фен Dyson',
    image: 'https://i.postimg.cc/XYdkb2jQ/IMG-1980.jpg'
  },
  {
    id: 4,
    name: 'SPA-сертифікат',
    image: 'https://i.postimg.cc/3xmFTL8L/IMG-1982.jpg'
  },
  {
    id: 5,
    name: 'Iphone',
    image: 'https://i.postimg.cc/JzZ5LTrp/IMG-1983.jpg'
  },
  {
    id: 6,
    name: 'Парфуми Chanel',
    image: 'https://i.postimg.cc/Cxksgvh6/IMG-1984.jpg'
  }
];

const reviewsData = [
  { id: 1, src: 'https://i.postimg.cc/YqNP5BRB/photo-1-2025-12-07-12-58-44.jpg', alt: 'Відгук 1' },
  { id: 2, src: 'https://i.postimg.cc/2Sztm996/photo-10-2025-12-07-12-58-44.jpg', alt: 'Відгук 2' },
  { id: 3, src: 'https://i.postimg.cc/qvkF0DbP/photo-2-2025-12-07-12-58-44.jpg', alt: 'Відгук 3' },
  { id: 4, src: 'https://i.postimg.cc/mgbnRpXK/photo-3-2025-12-07-12-58-44.jpg', alt: 'Відгук 4' },
  { id: 5, src: 'https://i.postimg.cc/FH96mCCt/photo-4-2025-12-07-12-58-44.jpg', alt: 'Відгук 5' },
  { id: 6, src: 'https://i.postimg.cc/8z1YDXXQ/photo-5-2025-12-07-12-58-44.jpg', alt: 'Відгук 6' },
  { id: 7, src: 'https://i.postimg.cc/NjgnYCCs/photo-9-2025-12-07-12-58-44.jpg', alt: 'Відгук 7' },
  { id: 8, src: 'https://i.postimg.cc/Gmcfrggc/photo-8-2025-12-07-12-58-44.jpg', alt: 'Відгук 8' },
  { id: 9, src: 'https://i.postimg.cc/wj6rH44H/photo-7-2025-12-07-12-58-44.jpg', alt: 'Відгук 9' },
  { id: 10, src: 'https://i.postimg.cc/mgbnRpp4/photo-6-2025-12-07-12-58-44.jpg', alt: 'Відгук 10' }
];

const forModelsData = {
  title: 'МОДЕЛЯМ',
  subtitle: 'Професійна підтримка і стабільний розвиток',
  description:
    'BMGroup спеціалізується на комплексному менеджменті профілів для закордонних преміум‑платформ. Ми займаємося реєстрацією та верифікацією, підготовкою якісного контенту, модерацією та підтримкою активності анкети — щоб ви отримували стабільний дохід і максимальну монетизацію без особистих зустрічей. Виплати здійснюються регулярно на банківську картку, PayPal або криптогаманець. Гарантуємо прозорість нарахувань і захист ваших персональних даних.',
  opportunities: [
    {
      title: 'Професійний менеджмент профілів',
      description:
        'Повний супровід профілю: вибір оптимальних платформ, коректна верифікація, оформлення анкети та системне ведення й розкручування профілю для збільшення активності та доходу.',
      icon: 'camera'
    },
    {
      title: 'Підтримка та ознайомлення з форматом роботи',
      description:
        'Інструкції щодо контенту (фото, короткі відео, спліти), правила відеопідтверджень та рекомендації для стабільного збереження доходу та рейтингу.',
      icon: 'graduation-cap'
    },
    {
      title: 'Доступ до міжнародних сайтів',
      description:
        'Підключення до перевірених партнерських платформ у США та Європі з акцентом на безпечну дистанційну роботу й ефективну монетизацію вашої краси.',
      icon: 'globe'
    },
    {
      title: 'Фінансова прозорість та супровід',
      description:
        'Прозора схема нарахувань і допомога у виборі оптимального способу виплат. Надаємо базову юридичну та податкову консультацію у межах співпраці.',
      icon: 'briefcase'
    }
  ],
  requirements: [
    'Вік від 18 років та до 70 років',
    'Фотогенічність та відповідальне ставлення до регулярного надання матеріалу для роботи',
    'Готовність записувати короткі відео за вимогою платформи для підтвердження активності',
    'Дотримання рекомендацій менеджера щодо контент‑стратегії та оновлень анкети'
  ]
};

const iconMap = {
  camera: Camera,
  'graduation-cap': GraduationCap,
  globe: Globe,
  briefcase: Briefcase
};

// === ПРЕЗЕНТАЦІЙНІ КОМПОНЕНТИ ===

const Hero = () => (
  <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-black pt-24 pb-16">
    <div className="absolute inset-0 opacity-30 bg-[radial-gradient(ellipse_at_top_right,#064e3b,transparent)]" />
    <div className="container mx-auto px-4 relative z-10">
      <div className="max-w-3xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-extrabold text-white leading-tight mb-4">
          {forModelsData.title}
        </h1>
        <p className="text-2xl text-emerald-500 font-medium mb-6">{forModelsData.subtitle}</p>
        <p className="text-gray-300 text-lg leading-relaxed mb-8">{forModelsData.description}</p>
        <div className="flex justify-center">
          <Link to="/contact">
            <Button size="lg" className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4">
              Подати заявку
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </section>
);

const Opportunities = () => (
  <section className="py-12 md:py-16 bg-zinc-950">
    <div className="container mx-auto px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center">Що ми пропонуємо</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {forModelsData.opportunities.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-2xl flex items-center gap-4 hover:bg-white/10 transition-all duration-300"
              >
                <div className="flex-none w-14 h-14 flex items-center justify-center rounded-lg bg-emerald-500/10">
                  <Icon className="text-emerald-500 w-6 h-6" />
                </div>
                <div className="min-w-0">
                  <h3 className="text-white text-lg font-semibold mb-2">{item.title}</h3>
                  <p className="text-gray-300 leading-relaxed">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

const Requirements = () => (
  <section className="py-12 md:py-16 bg-black">
    <div className="container mx-auto px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">Формат співпраці</h2>
        <p className="text-gray-400 mb-8">
          Для комфортної та стабільної співпраці ми дотримуємось простих умов:
        </p>
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-5 md:p-8 rounded-2xl">
          <ul className="grid gap-4">
            {forModelsData.requirements.map((req, index) => (
              <li key={index} className="flex items-center gap-4">
                <div className="flex-shrink-0">
                  <div className="w-7 h-7 rounded-full bg-emerald-500/20 flex items-center justify-center">
                    <div className="w-2.5 h-2.5 rounded-full bg-emerald-500" />
                  </div>
                </div>
                <div className="text-left">
                  <span className="text-gray-200 text-lg leading-relaxed">{req}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

const ModelsGallery = () => (
  <section className="py-12 md:py-16 bg-zinc-950">
    <div className="px-4">
      <div className="mx-auto max-w-screen-xl">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center">
          Наші моделі
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
          {modelsData.map((model) => (
            <Card
              key={model.id}
              className="w-full min-w-0 bg-white/5 border border-white/10 rounded-2xl overflow-hidden"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={model.image}
                  alt={model.name}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="p-2 md:p-4">
                <h3 className="text-white text-sm md:text-lg font-semibold truncate">
                  {model.name}
                </h3>
                <p className="text-emerald-500 text-xs md:text-sm flex items-center gap-1 mt-1">
                  <img src={model.flag} alt="" className="w-3 h-3 md:w-4 md:h-4" />
                  <span className="truncate">{model.categoryText}</span>
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  </section>
);

// === ЗМІНИ ТУТ (GiftsGallery) ===
const GiftsGallery = () => (
  <section className="py-12 md:py-16 bg-black">
	<div className="px-4">
	  <div className="mx-auto max-w-screen-xl">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center">
          Приклади подарунків для моделей
        </h2>

        <p className="text-gray-400 text-center max-w-3xl mx-auto mb-10">
          Користувачі платформи можуть надсилати подарунки дівчатам.
          Після підтвердження вони конвертуються у реальні кошти на вашому балансі.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
		  {giftsData.map((gift) => (
			<Card
			  key={gift.id}
			  className="min-w-0 bg-white/5 border border-white/10 rounded-2xl overflow-hidden"
			>
			  <div className="aspect-square overflow-hidden">
				<img
				  src={gift.image}
				  alt={gift.name}
				  className="w-full h-full object-cover"
				/>
			  </div>

			  <div className="p-2 md:p-4 text-center">
				<h3 className="text-white text-sm md:text-lg font-semibold">
				  {gift.name}
				</h3>
			  </div>
			</Card>
		  ))}
		</div>

      </div>
    </div>
  </section>
);

const ReviewsCarousel = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const total = reviewsData.length;

  const prev = () => setIndex((i) => (i - 1 + total) % total);
  const next = () => setIndex((i) => (i + 1) % total);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % total);
    }, 4500);
    return () => clearInterval(timer);
  }, [paused, total]);

  return (
    <section className="py-12 md:py-16 bg-zinc-950">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Відгуки наших моделей</h2>
          <p className="text-gray-400 mb-6">Реальні скріни переписок та відгуків від дівчат, які працюють з нами.</p>

          <div
            className="relative"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
          >
            {/* Картинка */}
            <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
              <img
                src={reviewsData[index].src}
                alt={reviewsData[index].alt}
                className="w-full h-auto max-h-[500px] object-contain bg-black aspect-[9/16] sm:aspect-auto"
                decoding="async"
                loading="lazy"
              />
            </div>

            {/* Кнопки навігації */}
            <button
              onClick={prev}
              aria-label="Попередній відгук"
              className="absolute top-1/2 -translate-y-1/2 left-3 sm:left-4 bg-black/60 hover:bg-black/70 text-white p-2 rounded-full shadow-lg"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>

            <button
              onClick={next}
              aria-label="Наступний відгук"
              className="absolute top-1/2 -translate-y-1/2 right-3 sm:right-4 bg-black/60 hover:bg-black/70 text-white p-2 rounded-full shadow-lg"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>

          {/* Індикатори */}
          <div className="flex items-center justify-center gap-2 mt-4">
            {reviewsData.map((r, i) => (
              <button
                key={r.id}
                onClick={() => setIndex(i)}
                aria-label={`Перейти до відгуку ${i + 1}`}
                className={`w-2.5 h-2.5 rounded-full ${i === index ? 'bg-emerald-500' : 'bg-white/20'}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const FinalCTA = () => (
  <section className="py-24 bg-black">
    <div className="container mx-auto px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Готові зробити перший крок?</h2>
        <p className="text-gray-300 text-lg mb-8">
          Заповніть коротку заявку, і наш менеджер зв'яжеться з вами для безкоштовної консультації та плану дій.
        </p>
        <div className="flex justify-center gap-4">
          <Link to="/contact">
            <Button size="lg" className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4">
              Подати заявку
            </Button>
          </Link>
          <Link to="/contact">
            <Button size="lg" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4">
              Звʼязатися з нами
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </section>
);

const howItWorksSteps = [
  {
    number: '01',
    title: 'Подаєте заявку',
    description: 'Заповнюєте коротку форму або пишете менеджеру в Telegram. Відповідаємо протягом 1 години.'
  },
  {
    number: '02',
    title: 'Консультація',
    description: 'Менеджер пояснює формат роботи, відповідає на всі питання. Без тиску та зобов\'язань.'
  },
  {
    number: '03',
    title: 'Запуск профілю',
    description: 'Ми беремо на себе реєстрацію, верифікацію та налаштування. Зазвичай 3–7 днів.'
  },
  {
    number: '04',
    title: 'Регулярні виплати',
    description: 'Щотижневі або двотижневі виплати на картку, PayPal або крипто. Повна прозорість нарахувань.'
  }
];

const faqData = [
  {
    q: 'Як і коли здійснюються виплати?',
    a: 'Виплати — щотижнево або двічі на місяць на банківську картку, PayPal або криптогаманець. Графік узгоджується з менеджером.'
  },
  {
    q: 'Чи безпечні мої персональні дані?',
    a: 'Так. Ваші дані захищені та не передаються третім особам. Ми дотримуємось принципу мінімального розкриття інформації.'
  },
  {
    q: 'Скільки часу займає запуск?',
    a: 'Зазвичай 3–7 днів від подачі заявки до першої активності профілю. Всі технічні питання ми беремо на себе.'
  },
  {
    q: 'Чи можу я зупинити співпрацю в будь-який момент?',
    a: 'Так, без штрафів і складних процедур. Достатньо повідомити менеджера.'
  },
  {
    q: 'Скільки можна заробляти?',
    a: 'Сума залежить від активності та платформи. Середній місячний дохід учасниць — від $500 до $3 000+. Менеджер надасть реалістичний прогноз на консультації.'
  }
];

const HowItWorks = () => (
  <section className="py-12 md:py-16 bg-zinc-950">
    <div className="container mx-auto px-4">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">Як це працює</h2>
        <p className="text-gray-400 text-center mb-10">Від заявки до першої виплати — чотири прості кроки</p>
        <div className="grid md:grid-cols-4 gap-6">
          {howItWorksSteps.map((step, index) => (
            <div key={index} className="relative text-center group">
              {index < howItWorksSteps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[60%] w-full h-px bg-emerald-500/20 z-0" />
              )}
              <div className="relative z-10">
                <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center group-hover:bg-emerald-500/20 transition-colors">
                  <span className="text-emerald-500 text-2xl font-bold">{step.number}</span>
                </div>
                <h3 className="text-white font-semibold mb-2">{step.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  return (
    <section className="py-12 md:py-16 bg-black">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">Часті питання</h2>
          <p className="text-gray-400 text-center mb-10">Відповіді на найпоширеніші запитання</p>
          <div className="space-y-3">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="bg-white/5 border border-white/10 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-white/5 transition-colors"
                >
                  <span className="text-white font-medium pr-4">{item.q}</span>
                  <span className={`text-emerald-500 text-xl flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>+</span>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-400 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Models = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black min-h-screen text-white">
      <Hero />
      <HowItWorks />
      <Opportunities />
      <Requirements />
      <ModelsGallery />
      <GiftsGallery />
      <ReviewsCarousel />
      <FAQ />
      <FinalCTA />
    </div>
  );
};

export default Models;
